import {
    Card, CardActionArea, CardContent,
    Grid, Stack, Typography,
    useMediaQuery,
} from "@mui/material";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

export default function Programs({navigate}) {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    //todo: a modifier par appel API
    const listProgramAvailable = {
        QR_CODE : {
            name : 'QR code générator',
            icon : <QrCode2Icon sx={{color: "primary.main", fontSize:'96px'}} />,
            desc : 'Générer vos QR code pour vos site',
            href : 'http://localhost:3001'
        },
        PWD : {
            name : 'Mot de passe',
            icon : <LockOpenOutlinedIcon sx={{color: "primary.main", fontSize:'96px'}} />,
            desc : 'Sécuriser et enregistrez vos mot de passe',
            href : '#'
        }
    }

    return (
        <Grid
            container
            direction="row"
            sx={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width:'100%'
            }}
            spacing={4}
        >
            {
                Object.values(listProgramAvailable).map(elem=>(
                    <Grid size={{xs:12, sm:6, md:3.5}}>
                        <Card sx={{ width:'100%', marginTop:3 }} onClick={()=>{
                            // navigate(cardToUse.href);
                            window.location.href = elem.href
                        }}
                        >
                            <CardActionArea sx={{paddingTop: 2}}>
                                {elem.icon}

                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {elem.name}
                                    </Typography>
                                    <Typography gutterBottom variant="body2" color="text.secondary">
                                        {elem.desc}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>


                    </Grid>
                ))
            }
        </Grid>

    )
}